import { Tooltip } from 'antd';
import { ReactComponent as HelpIcon } from '../../../../assets/icons/help-icon.svg';
import IconButton from '../../../../views/components/Buttons/IconButton';
import SvgConverter from '../../../../views/components/Common/SvgConverter';
import { helpCenterEventEmitter } from '../../utils/event-emitter';

export const HelpCenterButton = ({ section, containerStyle = {}, iconStyle = {} }) => {
  const handleHelpIconClick = () => {
    helpCenterEventEmitter.emit('open', section);
  };

  return (
    <Tooltip placement="bottom" title="Help Center">
      <div style={containerStyle}>
        <IconButton onClick={handleHelpIconClick}>
          <SvgConverter Icon={HelpIcon} color="red" style={iconStyle} />
        </IconButton>
      </div>
    </Tooltip>
  );
};
